module.exports = __webpack_public_path__ + "static/media/github.43a3d4d4.png";